module.exports = __webpack_public_path__ + "img/boton-texto-29.13b2e519.png";